import { render, staticRenderFns } from "./returnCharts.vue?vue&type=template&id=3bc0c375"
import script from "./returnCharts.vue?vue&type=script&lang=js"
export * from "./returnCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc0c375')) {
      api.createRecord('3bc0c375', component.options)
    } else {
      api.reload('3bc0c375', component.options)
    }
    module.hot.accept("./returnCharts.vue?vue&type=template&id=3bc0c375", function () {
      api.rerender('3bc0c375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/charts/returnCharts.vue"
export default component.exports